<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="boms"
        @select="selectHandle"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="otherBtn">
        <el-button :disabled="(!selection.length || !limits.delAuth)" type="danger" @click="deleteRows"> 批量删除 </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="编号:">
            <el-input v-model.trim="filter.bomNo" placeholder="请输入bom编号" clearable/>
          </el-form-item>
          <el-form-item label="物料编号:">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称:">
            <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="审核状态:">
            <el-select v-model="filter.status" clearable placeholder="请选择审核状态">
              <el-option v-for="(item, index) in statusList" :key="index" :label="item.name" :value="item.code"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.checkAuth" type="success" :disabled="scope.row.status === 20||scope.row.status === 99" @click="passHandler(scope.row.pkid)"> 审核 </el-button>
        <el-button v-if="limits.zfAuth" :disabled="scope.row.status === 99" type="info" @click="toVoidHandler(scope.row.pkid)"> 作废 </el-button>
        <el-button type="warning" @click="$refs.editPage.open(scope.row,true)"> 详情</el-button>
      </template>
    </view-table>
    <bom-edit ref="editPage" :options="options" @save-success="loadData(1)"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import BomEdit from "@/views/information/BomManage/BomEdit";

  export default {
    name: "BomManageList",
    components: {BomEdit, ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(135),
          editAuth: this.$auth(136),
          delAuth: this.$auth(139),
          checkAuth: this.$auth(137),
          zfAuth: this.$auth(138),
        },
        filter: {
          bomNo: "",
          status: "",
          materialNo: "",
          materialName: "",
        },
        columnsProperty: [
          {
            key: "bomNo",
            align: "center",
            minWidth: 220,
            tooltip: true,
          },
          {
            key: "bomTypeName",
            align: "center",
            width: 120,
          },
          {
            key: "materialNo",
            align: "center",
            width: 180,
          },
          {
            key: "materialName",
            align: "center",
            minWidth: 240,
            tooltip: true,
          },
          {
            key: "versionNo",
            align: "center",
            width: 80,
          },
          {
            key: "statusName",
            align: "center",
            width: 100,
          },
          {
            key: "creatorName",
            align: "center",
            width: 120,
          },
          {
            key: "createTime",
            align: "center",
            width: 180,
          },
          {
            key: "useStatusName",
            align: "center",
            width: 180,
          },
          {
            key: "action",
            align: "center",
            width: 290,
            slot: "action",
            fixed: "right",
          },
        ],
        selection: [],
        statusList: [],
        disabled: false,
        options: [],
      };
    },

    mounted() {
      this.getStatusDict("BaseDataStatus");
    },

    methods: {
      getStatusDict(dictName) {
        this.$http.get("basic", `dictionaries/dictEnum/${dictName}`).then((resp) => {
          if (resp.success) {
            this.statusList = resp.data;
          }
        });
      },

      // checkbox
      selectHandle(selection) {
        this.selection = selection;
      },

      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除(单删、多删)
      deleteHandle(row) {
        this.$http.delete("basic", "boms", row.pkid).then((res) => {
          if (res.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          }
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      // 批量删除
      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "boms/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 作废
      toVoidHandler(pkid) {
        this.$confirm("确定作废吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `boms/abort/${pkid}`).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("作废成功");
            }
          });
        });
      },

      // 审核
      passHandler(pkid) {
        this.$confirm("确定审核通过吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", `boms/approve/${pkid}`).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("审核成功");
            }
          });
        });
      },

    },
  };
</script>